// extracted by mini-css-extract-plugin
export default {"header":"AutoSearchLinks_header__Lf-jL","links":"AutoSearchLinks_links__zLueH"};